import React from "react";

function CauseLists() {
  return <div>CauseLists CauseLists</div>;
}

export default CauseLists;
